import React from 'react';
import PropTypes from 'prop-types';
import './PhotoApproval.css';

const ActionButton = ({ icon, onClick }) => (
  <div className='photoApprovalActionButton' onClick={onClick}>
    { icon }
  </div>
);

ActionButton.propTypes = {
  icon: PropTypes.element,
  onClick: PropTypes.func
};

export default ActionButton;
